import { Pipe, PipeTransform } from '@angular/core';
import {DateTimeService} from '../date-time.service';

@Pipe({
  name: 'brdecimal'
})
export class BrDecimalPipe implements PipeTransform {

  constructor(private dateTimeService: DateTimeService) {
  }

  transform(decimalValue:any): string {
    if (!decimalValue) return null;
    return decimalValue.toString().replace('.',',');
  }
}
